import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'components/Modal';
import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog';
import styles from './CreditAdminModal.m.sass';
import { Form, Input } from '../../../components/Form';
import { SwitchCheckbox } from '../../../components/SwitchCheckbox';
import round from 'lodash';
import formatCurrency from '../../../utils/formatCurrency';
var CreditAdminModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function CreditAdminModal() {
    _classCallCheck(this, CreditAdminModal);
    return _callSuper(this, CreditAdminModal, arguments);
  }
  _inherits(CreditAdminModal, _React$Component);
  return _createClass(CreditAdminModal, [{
    key: "render",
    value: function render() {
      var state = this.props.state;
      var method = state.billingStore.billingMethods.find(function (x) {
        return state.targetId === x.id;
      });
      var balance = method && method.balance ? round(method.balance / 100, 2) : 0;
      var limit = method && method.limit ? round(method.limit / 100, 2) : 0;
      return /*#__PURE__*/React.createElement(Modal, {
        onRequestClose: function onRequestClose() {
          return state.hideCreditAdminModal();
        },
        isOpened: state.showingCreditAdminModal,
        position: "top"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: state.updateCredit.bind(state)
      }, /*#__PURE__*/React.createElement(Dialog, {
        className: styles.dialog
      }, !state.billingStore.rootStore.sessionStore.workspace.corporate && /*#__PURE__*/React.createElement("img", {
        className: styles.img,
        src: require('../../../assets/img/graphicUpdateLimit.svg')
      }), /*#__PURE__*/React.createElement(DialogTitle, {
        className: styles.dialogTitle
      }, "Update Credit Account", /*#__PURE__*/React.createElement("p", {
        className: styles.subTitle
      }, "Modify the Credit Limit or change the Current Balance for this credit account")), /*#__PURE__*/React.createElement(DialogContent, {
        className: styles.dialogContent
      }, /*#__PURE__*/React.createElement(Input, {
        type: "number",
        min: 0,
        model: state.creditAdminForm,
        field: "limitAmount",
        label: "Credit Limit"
      }), /*#__PURE__*/React.createElement("strong", null, "Current Limit:", ' ', /*#__PURE__*/React.createElement("span", {
        className: styles.creditLimit
      }, formatCurrency(limit))), /*#__PURE__*/React.createElement("div", {
        className: styles.spacer
      }), /*#__PURE__*/React.createElement(Input, {
        type: "number",
        min: 0,
        model: state.creditAdminForm,
        step: 0.01,
        field: "balanceEditAmount",
        label: "Insert Amount To Add Or Remove"
      }), /*#__PURE__*/React.createElement(Input, {
        type: "string",
        model: state.creditAdminForm,
        field: "description",
        label: "Description"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.toggle
      }, /*#__PURE__*/React.createElement("strong", null, "Current Balance:", ' ', /*#__PURE__*/React.createElement("span", {
        className: balance > 0 ? styles.balanceGood : styles.balanceWarning
      }, formatCurrency(balance))), /*#__PURE__*/React.createElement(SwitchCheckbox, {
        disabled: state.updateCredit.pending,
        className: styles.switchbox,
        success: true,
        trueLabel: "Add",
        falseLabel: "Remove",
        value: state.adjustmentAddOrRemove,
        onChange: state.toggleAdjustmentSwitch
      }))), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButton, {
        onClick: function onClick(e) {
          return e.stopPropagation() || state.hideCreditAdminModal();
        }
      }, "Back"), /*#__PURE__*/React.createElement(DialogButton, {
        submit: true,
        primary: true,
        disabled: state.updateCredit.pending
      }, state.updateCredit.pending ? 'Adding' : 'Add')))));
    }
  }]);
}(React.Component)) || _class;
export { CreditAdminModal as default };
//# sourceMappingURL=index.js.map
